import React from 'react';
import './LegalPage.css';

function TermsOfService() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service &amp; SMS Terms</h1>
        <p className="legal-updated">Last Updated: February 2026</p>

        <p>
          These Terms of Service govern your use of the SMPW Masters Event volunteer
          registration and scheduling system ("the Service") operated by the SMPW Masters
          Event Scheduling Team for the 2026 Augusta Masters SMPW Event.
        </p>

        <h2>Acceptance of Terms</h2>
        <p>
          By registering as a volunteer or driver, or by submitting your availability through
          any link we provide, you agree to these Terms of Service and our{' '}
          <a href="/privacy">Privacy Policy</a>.
        </p>

        <h2>Use of the Service</h2>
        <p>The Service is intended solely for:</p>
        <ul>
          <li>Volunteer and driver registration for the 2026 Augusta Masters SMPW Event</li>
          <li>Submitting your availability for event shift assignments</li>
          <li>Receiving scheduling confirmations and event communications</li>
        </ul>
        <p>
          You agree to provide accurate and complete information when registering, and to
          notify the scheduling team of any changes to your availability or contact information.
        </p>

        <h2>SMS Terms &amp; Conditions</h2>
        <p>
          By providing your mobile phone number, you expressly consent to receive SMS text
          messages from the SMPW Masters Event Scheduling Team. Messages may include:
        </p>
        <ul>
          <li>Availability request links</li>
          <li>Shift assignment confirmations</li>
          <li>Urgent notifications regarding weather delays, location changes, or emergencies</li>
        </ul>

        <p><strong>Message frequency:</strong> Message frequency will vary. You may receive
        up to a few messages per day during the event period (April 9–12, 2026).</p>

        <p><strong>Message and data rates may apply.</strong> Check with your mobile carrier
        if you are unsure about applicable rates.</p>

        <p><strong>To opt out:</strong> Reply <strong>STOP</strong> to any SMS message to
        unsubscribe. You will receive a one-time confirmation message, after which no further
        SMS messages will be sent to your number.</p>

        <p><strong>For help:</strong> Reply <strong>HELP</strong> to any SMS message or
        contact your congregation's event coordinator directly.</p>

        <p>
          Opting out of SMS does not cancel your volunteer registration; it only stops SMS
          communications. You may still receive email communications if you have provided
          an email address.
        </p>

        <h2>Supported Carriers</h2>
        <p>
          SMS messaging is available on most major U.S. carriers. Carrier support is not
          guaranteed for all carriers.
        </p>

        <h2>No Commercial Use</h2>
        <p>
          Your phone number and personal information will not be used for any commercial
          marketing purposes and will not be sold or transferred to third parties.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          The Service is provided on an "as is" basis for event coordination purposes only.
          The SMPW Masters Event Scheduling Team is not liable for any technical failures,
          message delivery issues, or scheduling errors beyond our reasonable control.
        </p>

        <h2>Changes to These Terms</h2>
        <p>
          We reserve the right to update these Terms at any time. Continued use of the
          Service following any changes constitutes your acceptance of the updated Terms.
        </p>

        <h2>Contact</h2>
        <p>
          For questions about these Terms, please contact a member of your congregation's
          Service Committee.
        </p>
      </div>
    </div>
  );
}

export default TermsOfService;
